import {
  fetchCianApiSiteV1GetUserDataByRequest,
  TCianApiSiteV1GetUserDataByRequestResponse,
} from '../../repositories/monolith-python/cian-api/site/v1/get-user-data-by-request';
import { IFastFiltersUserResponseSchema } from '../../repositories/monolith-python/entities/schemas/FastFiltersUserResponseSchema';
import { IApplicationContext } from '../../types/applicationContext';

export async function getUser({
  httpApi,
  logger,
  custom,
}: IApplicationContext): Promise<IFastFiltersUserResponseSchema> {
  try {
    const { subdomain } = custom;

    const result: TCianApiSiteV1GetUserDataByRequestResponse = await fetchCianApiSiteV1GetUserDataByRequest({
      httpApi,
      config: { subdomain },
    });

    return result.response.data;
  } catch (error) {
    logger.warning(error, {
      comment: '[Degradation] Нет информации о пользователе, пользователь считается неавторизованным',
    });

    return {};
  }
}
